import { BooleanFieldDefinition } from "./getBooleanDefinition";
import { NumberFieldDefinition } from "./getNumberDefinition";
import { OptionsFieldDefinition } from "./getOptionsFieldDefinition";
import { OptionsGroupFieldDefinition } from "./getOptionsGroupDefinition";
import { TextFieldDefinition } from "./getTextDefinition";

export type DefinitionRecord = Record<string, FieldDefinition>;

export type FieldDefinition =
  | BooleanFieldDefinition
  | NumberFieldDefinition
  | OptionsFieldDefinition
  | OptionsGroupFieldDefinition
  | TextFieldDefinition;

export type FieldValues<T> = {
  [K in keyof T]: FieldValue<T[K]>;
};

// prettier-ignore
type FieldValue<T> =
  T extends BooleanFieldDefinition ? boolean :
  T extends NumberFieldDefinition ? number :
  T extends OptionsFieldDefinition | OptionsGroupFieldDefinition | TextFieldDefinition ? string :
  T extends Record<string, unknown> ? FieldValues<T> :
  never;

export function isFieldDefinition(value: object): value is FieldDefinition {
  return (
    typeof value === "object" &&
    value !== null &&
    "type" in value &&
    typeof value.type === "string"
  );
}
